import { cn } from '@/lib/utils';

export type AvatarProps = {
  name?: string;
  src?: string;
  size?: number;
  className?: string;
};

function initials(name?: string): string {
  if (!name) return '?';
  return name
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export function Avatar({ name, src, size = 36, className }: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={name ?? ''}
        width={size}
        height={size}
        className={cn('rounded-full border border-border object-cover', className)}
        loading="lazy"
      />
    );
  }
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-full bg-primary/15 font-medium text-primary',
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }}
      aria-hidden={!name}
    >
      {initials(name)}
    </span>
  );
}
